<template>
    <AccountViewBase :account="account" :loading="loading" :error="error">
        <div class="container-fluid content-type-24">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-xl-6 col-xl-offset-3">
                        <div class="content">
                            <div class="img failed">
                                <div class="icon-close-pos"></div>
                            </div>
                            <h1 class="h1">{{$t('views.payment_failed.title')}}</h1>
                            <p class="p">{{$t('views.payment_failed.description')}}</p>
                            <router-link :to="{name: 'subscription-order'}" class="btn-m btn-1">{{$t('views.payment_failed.buttons.order')}}</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </AccountViewBase>
</template>

<script>
    import AccountViewBase from '@/views/account/AccountViewBase';
    import i18nViewMixin from '@/mixins/i18nViewMixin';
    import accountMixin from '@/mixins/accountMixin';
    import { useOrderStore } from '@/stores/order';
    import { scrollToTop } from '@/utils/scroll';

    export default {
        name: 'AccountSettingsView',
        components: {
            AccountViewBase
        },
        mixins: [i18nViewMixin, accountMixin],
        data() {
            return {
                seo_title: 'views.payment_failed.seo_title',
                order_id: false,
            };
        },
        computed: {
            orderStore() {
                return useOrderStore();
            },
            matchingOrder() {
                return !!this.orderStore?.order?.order_id && this.orderStore.order.order_id === this.order_id;
            }
        },
        async mounted() {
            scrollToTop();
            this.order_id = this.$route.query.order_id || '';

            if(!this.matchingOrder) {
                this.orderStore.saveOrderSettings(true);
            }

            this.orderStore.resetOrder();
        }
    }
</script>
